import React, { PropTypes } from 'react';
import { Tabs, Modal, Input, Icon, Button, Upload, message, Spin } from 'antd';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import UserRoleStore from '../../stores/UserRoleStore';
import CreateTaskPage from "./CreateTaskPage";
import ClockIndexPage from "./ClockIndexPage";
import ClockClassesListPage from "./ClockClassesListPage";
const TabPane = Tabs.TabPane;
const { TextArea } = Input;

export default class NotificationsPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      classesWithNotificationsStatus: 0,
      activeKey: 'write'
    };

    if (!this.state.schoolId && this.state.currentRole.associatName == "school") {
      this.state.schoolId = this.state.currentRole.associatObj.id;
    } else {
      this.state.schoolId = this.state.currentRole.associatObj.schoolId;
    }
    // bind this
    this.onRolesChange = this.onRolesChange.bind(this);
    this.onViewTabClick = this.onViewTabClick.bind(this);
  }

  componentDidMount() {
    UserRoleStore.addChangeListener(this.onRolesChange);
    let activeKey = localStorage.getItem('tabKey')
    if (activeKey) {
      this.setState({
        activeKey
      })
      localStorage.removeItem('tabKey');
    }
  }

  componentWillUnmount() {
    UserRoleStore.removeChangeListener(this.onRolesChange);
  }

  onRolesChange() {
    this.setState({
      currentRole: CurrentRoleStore.getCurrentRole(),
    });
  }

  onViewTabClick(activeKey) {
    this.setState({
      activeKey
    })
  }

  render() {
    if (this.state.currentRole.associatName == "classRecord") { // common teacher, class admin
      return (
        <div className="notifications-page">
          <Tabs defaultActiveKey="write" onChange={this.onViewTabClick.bind(this)} activeKey={this.state.activeKey}>
            <TabPane tab="发布打卡任务" key="write">
              <CreateTaskPage currentRole={this.state.currentRole} schoolId={this.state.schoolId}/>
            </TabPane>
            <TabPane tab="查看已有打卡" key="view">
              <ClockIndexPage classId={this.state.currentRole.associatObj.id} activeKey={this.state.activeKey}/>
            </TabPane>
          </Tabs>
        </div>
      )
    } else { // school admin, grade admin
      return (
        <div className="notifications-page">
          <Tabs defaultActiveKey="write" onChange={this.onViewTabClick.bind(this)} activeKey={this.state.activeKey}>
            <TabPane tab="发布打卡任务" key="write">
              <CreateTaskPage currentRole={this.state.currentRole} schoolId={this.state.schoolId} />
            </TabPane>
            <TabPane tab="查看已有打卡" key="view">
              <ClockClassesListPage currentRole={this.state.currentRole} schoolId={this.state.schoolId} activeKey={this.state.activeKey}/>
            </TabPane>
          </Tabs>
        </div>
      )
    }
  }
}






// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/clock/ClockComponent.jsx